<template>
	<div class="stats-cards">

		<div class="stats-card">
			<div v-if="isLoading" class="stats-card__shimmer">
				<div class="shimmer shimmer-label"></div> 
				<div class="shimmer shimmer-value"></div> 
			</div>
			<template v-else>
			<div class="stats-card__header">
				<span class="stats-card__label">ACTIVE COURSES</span>
				<i class="fas fa-book-open stats-card__icon stats-card__icon--primary"></i>
			</div>
			<div class="stats-card__value">{{ activeCourses }}</div>
			</template>
		</div>

		<div class="stats-card">
			<div v-if="isLoading" class="stats-card__shimmer"> 
				<div class="shimmer shimmer-label"></div> 
				<div class="shimmer shimmer-value"></div> 
			</div>
			<template v-else>
			<div class="stats-card__header">
				<span class="stats-card__label">OVERALL PROGRESS</span>
				<i class="fas fa-chart-line stats-card__icon stats-card__icon--primary"></i>
			</div>
			<div class="stats-card__value">{{ overallProgress }}%</div>
			</template>
		</div>

		<div class="stats-card">
			<div v-if="isLoading" class="stats-card__shimmer">
				<div class="shimmer shimmer-label"></div> 
				<div class="shimmer shimmer-value"></div>
			</div>
			<template v-else>
			<div class="stats-card__header">
				<span class="stats-card__label">COURSES COMPLETED</span>
				<i class="far fa-check-circle stats-card__icon stats-card__icon--green"></i>
			</div>
			<div class="stats-card__value">{{ coursesCompleted.completed }} / {{ coursesCompleted.total }}</div>
			</template>
		</div>

		<div class="stats-card">
			<div v-if="isLoading" class="stats-card__shimmer"> 
				<div class="shimmer shimmer-label"></div> 
				<div class="shimmer shimmer-value"></div> 
			</div>
			<template v-else>
			<div class="stats-card__header">
				<span class="stats-card__label">STUDY STREAK</span>
				<i class="fas fa-fire stats-card__icon stats-card__icon--fire"></i>
			</div>
			<div class="stats-card__value"><img src="../../assets/images/fire-icon.svg" alt="fire" class="study-streak__fire-icon"/> {{ currentStudyStreak }}</div>
			</template>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
	name: "DashboardStatsCards",
	data() {
		return {
			isLoading: true
		}
	},
	async created() {
		try {
			await this.getUserStreak();
		}
		finally {
			this.isLoading = false;
		}
	},
	methods: {
		...mapActions("user", ["getUserStreak"]),
	},
	computed: {
		...mapState("productVariant", ["productVariantsProgress"]),
		...mapState("user", ["studyStreak"]),
		activeCourses() {
			return (
				this.user?.productVariants?.filter(
					(pv) => pv.subscriptionStatus?.toLowerCase() === "allowed"
				).length || 0
			);
		},
    overallProgress() {
      const progress = this.productVariantsProgress;

      const variants = this.user?.productVariants?.filter((pv) => pv.subscriptionStatus?.toLowerCase() === "allowed") || [];

      if (!variants.length) return 0;
			let total = 0,
				count = 0;

      variants.forEach((v) => {
				const p = progress?.[v.id];
				if (p && p.totalContent > 0) {
					total += (p.completedTotalContent / p.totalContent) * 100;
					count++;
				}
			});

			return count ? Math.round(total / count) : 0;
		},
		coursesCompleted() {
			const progress = this.productVariantsProgress;
			const variants = this.user?.productVariants || [];
			const completed = variants.filter((v) => {
				const p = progress?.[v.id];
				return p && p.totalContent > 0 && p.completedTotalContent >= p.totalContent;
			}).length;
			return { completed, total: variants.length };
		},
    currentStudyStreak() {
      if(this.studyStreak && this.studyStreak.currentStreak) {
        return this.studyStreak.currentStreak === 1 ? `${this.studyStreak.currentStreak} day` : `${this.studyStreak.currentStreak} days`;
      }

      return '0 days';
    }
	},
	props: {
		user:Object
	}
};
</script>
<style scoped>
.stats-cards {
	display: flex;
	gap: 16px;
	margin-bottom: 24px;
}

.stats-card {
	flex: 1;
	background: #fff;
	border: 1px solid var(--border-color);
	border-radius: 10px;
	padding: 18px 20px 22px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.stats-card__shimmer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 68px;
}
.shimmer {
        position: relative;
        overflow: hidden;
        background: #e5e7eb;
        border-radius: 4px;
}
.shimmer::after {
        content: "";
        position: absolute;
        top: 0;
        left: -150%;
        width: 150%;
        height: 100%;
        background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.7),
                transparent
        );
        animation: shimmer 1.4s infinite;
}
.shimmer-label {
        width: 55%;
        height: 11px;
}
.shimmer-value {
        width: 35%;
        height: 28px;
        border-radius: 6px;
}
@keyframes shimmer {
        100% {
                left: 150%;
        }
}
.stats-card__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 14px;
}

.stats-card__label {
	font-size: 11px;
	font-weight: 600;
	color: #6b7280;
	letter-spacing: 0.07em;
	text-transform: uppercase;
}

.stats-card__icon {
	font-size: 17px;
}

.stats-card__icon--primary {
	color: var(--primary-color, #dc2626);
}

.stats-card__icon--green {
	color: #16a34a;
}

.stats-card__icon--fire {
	color: #f97316;
}

.stats-card__value {
	font-size: 26px;
	font-weight: 700;
	color: #111827;
	display: flex;
	align-items: center;
	gap: 6px;
	line-height: 1.1;
}

@media (max-width: 992px) {
	.stats-cards {
		flex-wrap: wrap;
	}

	.stats-card {
		flex: 1 1 calc(50% - 8px);
		min-width: calc(50% - 8px);
	}
}

@media (max-width: 480px) {
	.stats-card {
		flex: 1 1 100%;
	}
}
.study-streak__fire-icon {
	width: 32px;
	height: 32px;
	vertical-align: middle;
	margin-left: 6px;
}
</style>
